import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

// Carousel static images
import movie1 from '../../Resources/movie1.jpg'
import movie2 from '../../Resources/movie2.jpg'
import movie3 from '../../Resources/movie3.jpg'

import './Home.css'

// Sub-Component files for Home page
import Navbar from '../Navbar/Navbar';
import Movies from '../Movies/Movies';
import Footer from '../Footer/Footer';

function Home() {
  return (
    <>
        <Navbar />
        <div className="carousel-container">
            <Carousel className="my-carousel" autoPlay  infiniteLoop={true} 
            interval={2500} transitionTime={1000}  showThumbs={false}>
                <div>
                    <img src={movie1} alt="" />
                </div>
                <div >
                    <img src={movie2} alt="" />
                </div>
                <div >
                    <img src={movie3} alt="" />
                </div>
            </Carousel>
        </div>
        <div className="movies-container">
            <div className="heading">Recommended movies</div>

            {/* This first one Movie component for rendering released movies */}
            <Movies release={true} />

            <div className="heading">Upcoming Movies</div>

            {/* The second one for rendering movies not released yet */}
            <Movies release={false} />
        </div>
        <Footer />
    </>
  )
}

export default Home
